import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import Box from '@material-ui/core/Box';
import { parseGoogleMapsURL } from 'utils/utils';
import { integrations } from 'config';

const GM_PROPS = parseGoogleMapsURL(integrations.googleMapsUrl);

const Map = ({
  type,
  zoom,
  center,
  children,
  setMapRef,
  onMapClick,
  defaultOptions,
  onZoomChanged,
  loadingElement,
  mapContainerStyle,
  ...props
}) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: GM_PROPS.key,
    language: GM_PROPS.language,
    libraries: GM_PROPS.libraries,
  });

  // eslint-disable-next-line
  const onLoad = useCallback((map) => setMapRef(map), [])
  return isLoaded ? (
    <GoogleMap
      key="gm-map"
      draggable={false}
      onClick={onMapClick}
      onZoomChanged={onZoomChanged}
      mapContainerStyle={mapContainerStyle || { height: `600px`, width: `100%` }}
      options={{
        scrollwheel: false,
        ...defaultOptions,
      }}
      zoom={zoom}
      onLoad={onLoad}
      {...props}
      center={center}
    >
      {children}
    </GoogleMap>
  ) : (
    loadingElement || <Box style={{ height: `100%`, width: `100%` }} />
  );
};

Map.propTypes = {
  setMapRef: PropTypes.func,
  onMapClick: PropTypes.func,
  onZoomChanged: PropTypes.func,
  zoom: PropTypes.number,
  center: PropTypes.object,
  defaultOptions: PropTypes.object,
  children: PropTypes.node.isRequired,
};

Map.defaultProps = {
  checked: false,
  zoom: 14,
  defaultOptions: {},
  setMapRef: () => {},
  onMapClick: () => {},
  onZoomChanged: () => {},
};

export default Map;
